import React, { useEffect, useState } from "react";

type EventEHRToggleTabButtonProps = {
  tabs: string[];
  onToggle: (activeTab: string) => void;
  defaultSelected: string;
  customWidth?: string;
  variant?: "contained" | "outlined" | "text"; // New optional variant prop
};

const EventEHRToggleTabButton: React.FC<EventEHRToggleTabButtonProps> = ({
  tabs,
  onToggle,
  defaultSelected,
  customWidth,
  variant, // Optional variant
}) => {
  const [activeTab, setActiveTab] = useState(defaultSelected);

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
    onToggle(tab);
  };

  useEffect(() => {
    setActiveTab(defaultSelected);
  }, [defaultSelected]);

  const getVariantStyles = (isActive: boolean) => {
    if (!variant) return {}; // Use original styles if no variant is provided

    switch (variant) {
      case "contained":
        return isActive
          ? {
              backgroundColor: "#005596",
              color: "#FFFFFF",
              border: "1px solid #005596",
              borderRadius: "4px",
            }
          : {
              backgroundColor: "#F9FAFB",
              color: "#727272",
              border: "1px solid transparent",
              borderRadius: "4px",
            };
      case "outlined":
        return isActive
          ? {
              backgroundColor: "#FFFFFF",
              color: "#005596",
              border: "1px solid #005596",
              borderRadius: "4px",
            }
          : {
              backgroundColor: "#F9FAFB",
              color: "#727272",
              border: "1px solid #E0E0E0",
              borderRadius: "4px",
            };
      case "text":
        return isActive
          ? {
              backgroundColor: "transparent",
              color: "#005596",
              borderRadius: "4px",
            }
          : {
              backgroundColor: "transparent",
              color: "#727272",
              borderRadius: "4px",
            };
      default:
        return {};
    }
  };

  return (
    <div
      className={`flex rounded-md border-[1px] py-[3.5px] px-[4px] gap-1 border-[#F5F5F5] bg-[#F9FAFB] justify-between h-auto`}
      style={{
        width: customWidth || "100%",
      }}
    >
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => handleTabClick(tab)}
          className={`text-sm font-medium gap-2 w-full py-2 ${
            !variant && activeTab === tab
              ? "bg-white text-[#005596] border-[1px] border-[#E9E9E9] rounded-[4px]"
              : !variant
                ? "text-[#727272]"
                : ""
          }`}
          style={{
            ...getVariantStyles(activeTab === tab),
          }}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default EventEHRToggleTabButton;
